module.exports = __webpack_public_path__ + "img/165201.616cb11e.jpg";